import Option from "../commons/model/Option";
import Practice from "../commons/model/Practice";
import Doctor from "../commons/model/Doctor";

const notAssignedOption = new Option("", i18n["Page.Patient.Not.Assigned"]);
export const buildPracticeOptions = (
  assignablePractices: Practice[],
  isInitialPractice: boolean
): Option[] => {
  const practiceOptions = assignablePractices.map(
    (practice) => new Option(practice.uid.value, practice.name)
  );
  if (isInitialPractice) {
    return practiceOptions.concat([notAssignedOption]);
  } else {
    return practiceOptions;
  }
};

export const buildDoctorTopOptions = (isInitialDoctor: boolean): Option[] => {
  if (isInitialDoctor) {
    return [notAssignedOption];
  } else {
    return [];
  }
};

export const buildDoctorGroupOptions = (assignableDoctors: Doctor[]): Map<string, Option[]> => {
  const practices = [
    ...new Map(
      assignableDoctors.flatMap((doctor) => doctor.practices).map((item) => [item.name, item])
    ).values(),
  ];
  const sortedPractices = practices.sort((a, b) => (a.name > b.name ? 1 : -1));
  return new Map(
    sortedPractices.map((practice) => [
      practice.name,
      assignableDoctors
        .filter(
          (doctor) =>
            doctor.practices
              .map((doctorPractice) => doctorPractice.uid.value)
              .indexOf(practice.uid.value) > -1
        )
        .map((doctor) => new Option(doctor.uid.value, doctor.name)),
    ])
  );
};
